<template>
  <div
    id="AB_OVERLAY"
    @click="handleOnOverlayClick"
    class="overlay-addressBook"
  >
    <div class="">
      <div class="addressbook-container">
        <FirstAddressBook
          class="bg-white innerAddressBook"
          :disableAddressBook="mountOptions && mountOptions.payload ? mountOptions.payload.disableAddressBook : false"
          :selectClient="selectClient"
          :clients="clients"
          :connectedUser="connectedUser"
          @quit="closeAddressBook"
          @addNewClient="addNewClient"
        />
        <CustomerForm
          class="bg-white innerAddressBook"
          :form="customerForm"
          :showPetDetails="showPetDetails"
          :getAddressSuggestions="getAddressSuggestions"
          :autocomplete="autocomplete"
          :closeAddressBook="closeAddressBook"
          :selectAutoComplete="selectAutoComplete"
          :loaders="loaders"
          @updateForm="updateForm"
          @saveClient="saveClient"
          @deleteClient="deleteClient"
          @quit="closeCustomerForm"
          @checkAvailability="checkEmailAvailability(customerForm.data.email)"
          v-if="customerForm.visible"
          :disableEditCustomer="mountOptions && mountOptions.payload ? mountOptions.payload.disableAddressBook : false"
        />
        <DeliveryAddress
          class="bg-white innerAddressBook"
          v-if="isDeliveryVisible"
          :form="customerForm"
          :getAddressSuggestions="getAddressSuggestions"
          :autocomplete="autocomplete"
          :selectAutoComplete="selectAutoComplete"
          @saveClient="saveClient"
          @deleteClient="deleteClient"
          @quit="handleOnDeliveryAddressQuit"
          @updateForm="updateForm"
        />
        <PetDetails
          class="bg-white innerAddressBook"
          :pet="petDetails.pet"
          :closeAddressBook="closeAddressBook"
          :uploadPicture="uploadPicture"
          :clientId="
            customerForm.data.id === connectedUser.identity.id
              ? -1
              : customerForm.data.id
          "
          @close="petDetails.displayPetDetails = false"
          @deletePet="deletePet"
          v-if="isPetDetailsVisible"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FirstAddressBook from '../scenes/addressBook/FirstAddressBook';
import { mapState } from 'vuex';
import DeliveryAddress from '../scenes/addressBook/DeliveryAddress';
import PetDetails from '../scenes/addressBook/PetDetails';
import { CONSTANTS } from '@/constants/guide';
import CustomerForm from '@/components/scenes/addressBook/CustomerForm';
import {setCookie} from "@/helpers/userHelper";

export default {
  name: 'AddressBook',
  components: { PetDetails, DeliveryAddress, CustomerForm, FirstAddressBook },
  data() {
    return this.getInitialState();
  },
  methods: {
    deleteClient(clientId, isPraxis) {
      const billing = this.customerForm.data.billingAddress;
      const clientName = `${ billing.firstname } ${ billing.lastname }`;
      this.$swal({
        title: `Möchten Sie ${ clientName } wirklich aus Ihrem Patientenregister entfernen?`,
        icon: 'question',
        iconHtml: '?',
        confirmButtonText: 'Ja',
        cancelButtonText: 'Nein',
        showCancelButton: true,
        confirmButtonColor: '#2778c4',
        allowOutsideClick: () => false,
        allowEscapeKey: () => false,
        allowEnterKey: () => true
      }).then(result => {
        if (result.isConfirmed) {
          this.$store
              .dispatch('addressBookModule/deleteClient', { clientId, isPraxis })
              .then(promise => {
                this.petDetails.displayPetDetails = false;
                this.closeCustomerForm('info');
              });
        }
      });
    },
    deletePet(petId) {
      this.$swal({
        title: ` Wollen Sie diesen Patienten wirklich löschen? \n Sie können die Daten nicht wiederherstellen.`,
        icon: 'question',
        iconHtml: '?',
        confirmButtonText: 'Ja',
        confirmButtonColor: '#2778c4',
        cancelButtonText: 'Nein',
        showCancelButton: true,
        allowOutsideClick: () => false,
        allowEscapeKey: () => false,
        allowEnterKey: () => true
      }).then(result => {
        if (result.isConfirmed) {
          this.$store
            .dispatch('addressBookModule/deletePet', petId)
            .then(promise => {
              this.petDetails.displayPetDetails = false;
              this.customerForm = {
                ...this.customerForm,
                pets: this.customerForm.pets.filter(pet => pet.id !== petId)
              };
            });
        }
      });
    },
    async handleOnOverlayClick({ target: { id } }) {
      if (id !== 'AB_OVERLAY') {
        return false;
      }

      const doClose = !!!this.customerForm.visible
          || await this.closeCustomerForm(this.customerForm.displayMode);

      if(doClose){
        this.closeAddressBook();
      }
    },
    handleOnDeliveryAddressQuit() {
      this.$swal({
        title: ` Möchten Sie die Änderungen wirklich verwerfen?`,
        icon: 'question',
        iconHtml: '?',
        confirmButtonText: 'Ja',
        cancelButtonText: 'Nein',
        showCancelButton: true,
        confirmButtonColor: '#2778c4',
        allowOutsideClick: () => false,
        allowEscapeKey: () => false,
        allowEnterKey: () => true
      }).then(result => {
        if (result.isConfirmed) {
          this.customerForm = {
            ...this.customerForm,
            data: {
              ...this.customerForm.data,
              isDifferentDeliveryAddress: false,
              deliveryAddress: this.getInitialState().customerForm.data
                .deliveryAddress
            }
          };
        }
      });
    },
    async validateAddress(address) {
      let reason = [];

      if (!address.prefix || address.prefix.trim() === "") {
        reason.push('prefix');
      }

      reason = [...reason, ...Object.keys(address).reduce((acc, attribute) => {
        if (String(address[attribute]) === '' && !!!['additional_address','company'].includes(attribute) ) {
          acc = [...acc, attribute];
        }
        return acc;
      }, [])];

      if (reason.length === 0 && address.country === 'DE') {
        const promise = await this.$store.dispatch(
          'addressBookModule/checkCompleteAddress',
          address
        );

        reason = promise.success === false ? promise.reason : [];
      }

      if (reason.length === 0) {
        return { success: true, reason: [] };
      } else {
        return {
          success: false,
          reason: reason
        };
      }
    },
    selectAutoComplete(field, value) {
      const addressType = this.autocomplete.addressType;
      this.customerForm.data[addressType][field] = value;
      this.autocomplete = {
        ...this.autocomplete,
        data: [],
        type: '',
        addressType: ''
      };
      if (field === 'post') {
        this.$store
          .dispatch(`addressBookModule/completeAddress`, {
            ...this.customerForm.data[addressType],
            field: 'city'
          })
          .then(promise => {
            if (promise.success === true) {
              if (promise.data.length === 1) {
                this.customerForm.data[addressType].city = promise.data[0].city;
              } else {
                this.autocomplete = {
                  ...this.autocomplete,
                  data: promise.data,
                  type: 'city',
                  addressType: addressType
                };
              }
            }
          });
      }
    },
    getAddressSuggestions(addressType, field) {
      this.autocomplete = {
        ...this.autocomplete,
        type: field,
        addressType: addressType,
        isFetching: true
      };

      this.$store
        .dispatch(`addressBookModule/completeAddress`, {
          ...this.customerForm.data[addressType],
          field: field
        })
        .then(promise => {
          this.autocomplete = {
            ...this.autocomplete,
            data: promise.data,
            isFetching: false
          };
        });
    },
    uploadPicture(payload) {
      this.$store
          .dispatch('addressBookModule/uploadPicture', payload.image, payload.petId)
        .then(promise => {
          if (promise.success === true) {
            this.petDetails = {
              ...this.petDetails,
              pet: { ...this.petDetails.pet, image: promise.data }
            };
            this.customerForm.pets = this.customerForm.pets.map(pet => {
              if (pet.id === payload.petId) {
                pet.image = promise.data;
              }
              return pet;
            });
          }
        });
    },
    showPetDetails(pet) {
      this.petDetails = {
        ...this.petDetails,
        displayPetDetails: true,
        pet: pet
      };
    },
    async closeCustomerForm(type) {
      if (
        type ===
        CONSTANTS.ADDRESSBOOK.CUSTOMER_FORM_DISPLAY_MODES.DISPLAY_INFORMATION
      ) {
        this.customerForm.visible = false;
        return true;
      }

      const result = await this.$swal({
        title: 'Wollen Sie Ihre Änderungen verwerfen?',
        showConfirmButton: true,
        confirmButtonColor: '#2778c4',
        showCancelButton: true,
        confirmButtonText: 'Ja',
        cancelButtonText: 'Nein'
      })
      this.customerForm.visible = !!!result.isConfirmed;
      return result.isConfirmed;
    },
    async saveClient(event) {
      if (event) {
        event.preventDefault();
      }
      const validTelRegex = /\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/
      const isTelephoneInvalid = !validTelRegex.test(this.customerForm.data.telephone);
      const isEmailValid = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(this.customerForm.data.email);
      const isEmailInvalid = !isEmailValid

      let billingAddressValidation = await this.validateAddress(
        this.customerForm.data.billingAddress
      );
      this.customerForm = {
        ...this.customerForm,
        validations: {
          ...this.customerForm.validations,
          billingAddress: billingAddressValidation.reason,
          isTelephoneInvalid,
          isEmailInvalid
        }
      };

      let deliveryAddressValidation = { success: true, reason: [] };
      if (this.customerForm.data.isDifferentDeliveryAddress === true) {
        deliveryAddressValidation = await this.validateAddress(
          this.customerForm.data.deliveryAddress
        );

        this.customerForm = {
          ...this.customerForm,
          validations: {
            ...this.customerForm.validations,
            deliveryAddress: deliveryAddressValidation.reason
          }
        };
      }

      if (isEmailInvalid) {
        this.$swal({
          text: 'Bitte korrigieren Sie die E-Mail-Adresse. Es muss ein @ enthalten sein.',
          showConfirmButton: true,
          confirmButtonColor: '#2778c4',
        });
        return false;
      } else if (isTelephoneInvalid) {
        this.$swal({
          text: 'Bitte geben Sie eine gültige Telefonnummer ein.',
          showConfirmButton: true,
          confirmButtonColor: '#2778c4',
        });
        return false;
      } else if (billingAddressValidation.success === false || deliveryAddressValidation.success === false) {
        this.customerForm = {
          ...this.customerForm,
          validations: {
            ...this.customerForm.validations,
            isFetching: false
          }
        };
        let message = 'Ihre Eingaben werden mit dem DHL-Adressbuch abgeglichen. Bitte wählen Sie aus den Vorschlägen.';
        if (billingAddressValidation.reason.includes('prefix') || deliveryAddressValidation.reason.includes('prefix')) {
          message = 'Bitte wählen Sie eine Anrede aus.';
        }
        if (billingAddressValidation.reason.includes('firstname') || deliveryAddressValidation.reason.includes('firstname')) {
          message = 'Vorname ist erforderlich.';
        }
        if (billingAddressValidation.reason.includes('lastname') || deliveryAddressValidation.reason.includes('lastname')) {
          message = 'Nachname ist erforderlich.';
        }
        this.$swal({
          text: message,
          showConfirmButton: true,
          confirmButtonColor: '#2778c4',
        });
        return false;
      }
      const emailUnavailable = await this.checkEmailAvailability(this.customerForm.data.email);
      if (emailUnavailable) {
        return false;
      }

      this.$store
        .dispatch('addressBookModule/saveClientData', this.customerForm)
        .then(promise => {
          this.$swal({
            icon: 'success',
            title: 'Ihre Angaben wurden gespeichert.',
            showConfirmButton: false,
            timer: 2000
          });
          if (promise.clientId === -1) {
            this.selectClient(
              this.connectedUser.identity.id,
              this.connectedUser.identity.name,
              true
            );
          } else {
            this.selectClient(promise.clientId, promise.clientName, false);
          }
        })
        .catch(error => {
          const errorMessage =
            typeof error === 'string'
              ? error
              : 'Ihre Eingabe ist fehlerhaft oder unvollständig.';
          this.$swal({
            text: errorMessage,
            showConfirmButton: true,
            confirmButtonColor: '#2778c4',
          });
        });
    },
    updateForm(formData) {
      this.customerForm = formData;
    },
    closeAddressBook() {
      this.$store.commit('addressBookModule/displayAddressBook');
    },
    handleAssignToClient(pets, clientId, clientName, isVet) {
      let petName = pets.map(pet => pet.petName).join(', ');
      this.$swal({
        title: `Möchten Sie ${petName} zu Kunde ${clientName} hinzufügen?`,
        icon: 'question',
        iconHtml: '?',
        confirmButtonText: 'Ja',
        confirmButtonColor: '#2778c4',
        cancelButtonText: 'Nein',
        showCancelButton: true
      }).then(result => {
        if (result.isConfirmed) {
          setCookie('client_id', isVet ? -1 : clientId);
          let promises = pets.map(item =>
              this.$store.dispatch('addressBookModule/assignPetToClient', {
                petId: item.petId,
                clientId: isVet ? -1 : clientId
              })
          );

          Promise.all(promises).then(() => {
            this.$store.commit('checkOutModule/putCartContent', {
              needsRefresh: true
            });
            this.closeAddressBook();
          });
        }
      });
    },
    selectClient(id, clientName = '', isVet = false) {
      this.petDetails.displayPetDetails = false;

      if (
        this.mountOptions.action ===
        CONSTANTS.ADDRESSBOOK.MOUNT_ACTIONS.ASSIGN_PET_TO_CLIENT
      ) {
        this.handleAssignToClient(
          this.mountOptions.payload,
          id,
          clientName,
          isVet
        );
        return;
      }
      this.loaders = {
        ...this.loaders,
        isLoadingClient: true,
        isLoadingPets: true
      };
      this.$store
        .dispatch('addressBookModule/getClient', { id: id, isVet: isVet })
        .then(promise => {
          if (promise.success === true) {
            setCookie('client_id', isVet > 0 ? -1 : id);
            this.customerForm = {
              ...this.customerForm,
              visible: true,
              isVet: isVet,
              displayMode:
                CONSTANTS.ADDRESSBOOK.CUSTOMER_FORM_DISPLAY_MODES
                  .DISPLAY_INFORMATION,
              data: {
                ...this.getInitialState().customerForm.data,
                ...promise.data
              }
            };
            this.$store.dispatch('checkOutModule/clearOtherClientItems', {
              id: id,
              isVet: isVet
            });
            this.loaders = {
              ...this.loaders,
              isLoadingClient: false
            };
          } else {
            console.log('Error retrieving the client');
          }
        });

      this.$store
        .dispatch('addressBookModule/getClientPets', { id: id, isVet: isVet })
        .then(promise => {
          this.customerForm = {
            ...this.customerForm,
            pets: promise.data
          };
          this.loaders = {
            ...this.loaders,
            isLoadingPets: false
          };
          if (
            this.mountOptions.action ===
            CONSTANTS.ADDRESSBOOK.MOUNT_ACTIONS.DISPLAY_PET
          ) {
            const pet = this.customerForm.pets.find(
              p => p.id === this.mountOptions.payload.petId
            );
            pet !== undefined && this.showPetDetails(pet);
            this.$store.commit('addressBookModule/resetLoaders');
          }
        });
    },
    addNewClient() {
      this.customerForm = {
        ...this.getInitialState().customerForm,
        displayMode:
          CONSTANTS.ADDRESSBOOK.CUSTOMER_FORM_DISPLAY_MODES.NEW_CLIENT,
        visible: true,
        config: this.customerForm.config
      };
    },
    getInitialState() {
      return {
        loaders: {
          isLoadingClient: false,
          isLoadingPets: false
        },
        customerForm: {
          visible: false,
          displayMode: 'new',
          config: {
            prefixes: []
          },
          data: {
            id: null,
            email: '',
            telephone: '',
            isPraxis: false,
            isDifferentDeliveryAddress: false,
            billingAddress: {
              prefix: '',
              firstname: '',
              lastname: '',
              additional_address: '',
              street1: '',
              street2: '',
              post: '',
              city: '',
              country: 'DE'
            },
            deliveryAddress: {
              prefix: '',
              firstname: '',
              lastname: '',
              additional_address: '',
              street1: '',
              street2: '',
              post: '',
              city: '',
              country: 'DE'
            }
          },
          pets: [],
          validations: {
            billingAddress: [],
            deliveryAddress: [],
            isTelephoneInvalid: false,
            isEmailInvalid: false,
            isFetching: false
          }
        },
        petDetails: {
          displayPetDetails: false,
          pet: {}
        },
        autocomplete: {
          data: [],
          type: '',
          addressType: '',
          isFetching: false
        }
      };
    },

    checkEmailAvailability: async function (email) {
      if (!email || email.length === 0) {
        return false;
      }

      const promise = await this.$store.dispatch('addressBookModule/getEmailAvailability', {email, clientId: this.customerForm.data.id});
      if (promise.success === true && promise.data.availability === false) {
        this.showEmailAlreadyTakenAlert()
        return true;
      }

      return false;
    },

    showEmailAlreadyTakenAlert() {
      this.$swal({
        icon: 'error',
        html:
            'Diese E-Mail-Adresse existiert bereits.</br> Bitte kontaktieren Sie uns unter <a href="tel:+49 (0)341 39298796">+49 (0)341 39298796</a> bzw. ' +
            'über <a href="mailto:praxis@futalis.de">praxis@futalis.de</a>',
        showCancelButton: false,
        showConfirmButton: true,
        confirmButtonColor: '#2778c4',
        confirmButtonText: 'OK',
        allowOutsideClick: () => true,
        allowEscapeKey: () => true,
        allowEnterKey: () => true,
      });
    }
  },
  computed: {
    ...mapState({
      connectedUser: state => state.authModule.user,
      clients: state => state.addressBookModule.vetClients,
      mountOptions: state => state.addressBookModule.mountOptions
    }),
    isDeliveryVisible() {
      return (
        this.customerForm.visible === true &&
        this.customerForm.displayMode !==
          CONSTANTS.ADDRESSBOOK.CUSTOMER_FORM_DISPLAY_MODES
            .DISPLAY_INFORMATION &&
        this.customerForm.data.isDifferentDeliveryAddress === true
      );
    },
    isPetDetailsVisible() {
      return (
        this.petDetails.displayPetDetails === true &&
        this.customerForm.displayMode ===
          CONSTANTS.ADDRESSBOOK.CUSTOMER_FORM_DISPLAY_MODES.DISPLAY_INFORMATION
      );
    }
  },
  mounted() {
    this.$store.dispatch('addressBookModule/getVetClients');
    this.$store
      .dispatch('addressBookModule/getClientFormOptions')
      .then(promise => {
        if (promise.success === true) {
          this.customerForm = {
            ...this.customerForm,
            config: {
              ...this.customerForm.config,
              prefixes: promise.prefixes.filter(p => p !== '')
            }
          };
        }
      });
    this.$store
      .dispatch('addressBookModule/getAllowedCountries')
      .then(promise => {
        if (promise.success === true) {
          this.$store.commit('addressBookModule/storeAllowedCountries', {
            countries: promise.countries
          });
        }
      });

    this.$store.dispatch('checkOutModule/getCartContent');

    if (
      this.mountOptions.action ===
      CONSTANTS.ADDRESSBOOK.MOUNT_ACTIONS.DISPLAY_NEW_CLIENT_FORM
    ) {
      this.addNewClient();
    }

    if (
      [
        CONSTANTS.ADDRESSBOOK.MOUNT_ACTIONS.DISPLAY_PET,
        CONSTANTS.ADDRESSBOOK.MOUNT_ACTIONS.DISPLAY_CLIENT
      ].includes(this.mountOptions.action)
    ) {
      this.selectClient(
        this.mountOptions.payload.clientId,
        '',
        this.mountOptions.payload.clientId === -1
      );
    }
  },
  beforeDestroy() {
    this.$store.commit('addressBookModule/resetState');
  }
};
</script>

<style scoped lang="css">
.overlay-addressBook {
  position: fixed;
  left: 0;
  top: -89px;
  right: 0;
  bottom: 0;
  max-height: 1000000px;
  max-width: 1000000px;
  overflow: auto;
  z-index: 99 !important;
  display: flex;
  background-color: rgba(0, 0, 0, 0.3);
}
.addressbook-container {
  display: flex;
}
@media (max-width: 768px) {
  .overlay-addressBook {
    display: block !important;
    overflow-y: auto;
    overflow-x: hidden;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
  .overlay-addressBook::-webkit-scrollbar {
    display: none; /* Chrome, Safari and Opera */
  }

  .addressbook-container {
    display: block !important;
  }
}
</style>
